const routerParams = {
    DISPLAY_VEHICLE_CHANGE_ALERT: "displayVehicleChangeAlert",
    DISPLAY_PIA_ALERT: "displayPiaAlert",
};

export { routerParams };
